import React from "react";
import WidgetCard from "../_shared/WidgetCard";
import styles from "./style.module.scss";

interface AdoptionGaugeProps {
  percent: number;
  caption: string;
  deltaPct: string;
  deltaLabel: string;
  ageAppropriate: string;
}

export default function AdoptionGauge({
  percent,
  caption,
  deltaPct,
  deltaLabel,
  ageAppropriate,
}: AdoptionGaugeProps) {
  const arcLen = Math.PI * 82;
  const dash = `${(arcLen * (percent / 100)).toFixed(1)} ${arcLen.toFixed(1)}`;

  return (
    <WidgetCard title="Adoption Rate" stretch>
      <div className={styles.body}>
        <div className={styles.gaugeWrap}>
          <svg viewBox="0 0 200 118" className={styles.gauge}>
            <path
              d="M18 108 A82 82 0 0 1 182 108"
              fill="none"
              stroke="var(--ho-line)"
              strokeWidth="16"
              strokeLinecap="round"
            />
            <path
              d="M18 108 A82 82 0 0 1 182 108"
              fill="none"
              stroke="var(--ho-primary)"
              strokeWidth="16"
              strokeLinecap="round"
              strokeDasharray={dash}
            />
          </svg>
          <div className={styles.gaugeValue}>{percent}%</div>
        </div>
        <div className={styles.caption}>{caption}</div>
        <div className={styles.stats}>
          <div className={styles.statBox}>
            <div className={styles.statGreen}>{deltaPct}</div>
            <div className={styles.statLabel}>{deltaLabel}</div>
          </div>
          <div className={styles.statBox}>
            <div className={styles.statTeal}>{ageAppropriate}</div>
            <div className={styles.statLabel}>age-appropriate</div>
          </div>
        </div>
      </div>
    </WidgetCard>
  );
}
